// Global Orders mock data — 60 orders with realistic variety

const sellerPool: Array<{ name: string; wsId: string }> = [
  { name: 'TechVault India', wsId: 'WS-TV-0891' },
  { name: 'FashionHub', wsId: 'WS-FH-1204' },
  { name: 'HomeEssentials Co', wsId: 'WS-HE-0567' },
  { name: 'GadgetWorld', wsId: 'WS-GW-0334' },
  { name: 'StyleStreet', wsId: 'WS-SS-0782' },
  { name: 'AutoParts Direct', wsId: 'WS-AP-0123' },
  { name: 'BookBazaar', wsId: 'WS-BB-0456' },
  { name: 'KitchenKing', wsId: 'WS-KK-0678' },
  { name: 'PetSupply Hub', wsId: 'WS-PS-0211' },
  { name: 'SportsZone', wsId: 'WS-SZ-0345' },
  { name: 'CraftCorner', wsId: 'WS-CC-0890' },
];

const marketplacePool: string[] = ['Amazon', 'Flipkart', 'Wish', 'Meesho', 'Coupang'];
const statusPool: string[] = ['New', 'Pending Confirmation', 'Confirmed', 'Packed', 'Shipped', 'Delivered', 'Canceled', 'Return Initiated', 'Returned', 'Refund Pending', 'Refunded'];
const paymentPool: string[] = ['COD', 'Prepaid'];
const riskPool: string[] = ['Low', 'Low', 'Low', 'Medium', 'Medium', 'High'];
const slaPool: string[] = ['On track', 'On track', 'On track', 'At risk', 'Breached'];
const cityPool: Array<{ city: string; state: string }> = [
  { city: 'Bengaluru', state: 'KA' }, { city: 'Mumbai', state: 'MH' },
  { city: 'Delhi', state: 'DL' }, { city: 'Chennai', state: 'TN' },
  { city: 'Hyderabad', state: 'TS' }, { city: 'Pune', state: 'MH' },
  { city: 'Kolkata', state: 'WB' }, { city: 'Ahmedabad', state: 'GJ' },
  { city: 'Jaipur', state: 'RJ' }, { city: 'Lucknow', state: 'UP' },
  { city: 'Chandigarh', state: 'CH' }, { city: 'Kochi', state: 'KL' },
];
const namePool: string[] = [
  'R***a K', 'S***h P', 'A***d M', 'P***a S', 'V***l R', 'N***a G',
  'K***n T', 'D***a B', 'M***a J', 'L***i C', 'T***r A', 'G***a D',
];

function seededRandom(seed: number): () => number {
  let s = seed;
  return () => { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
}

function generateOrders(): Record<string, any>[] {
  const orders: Record<string, any>[] = [];
  const rand = seededRandom(42);
  const pick = <T>(arr: T[]): T => arr[Math.floor(rand() * arr.length)];
  const pickInt = (min: number, max: number): number => Math.floor(rand() * (max - min + 1)) + min;

  for (let i = 1; i <= 60; i++) {
    const idx = String(i).padStart(4, '0');
    const seller = pick(sellerPool);
    const marketplace = pick(marketplacePool);
    const status = pick(statusPool);
    const payment = pick(paymentPool);
    const risk = pick(riskPool);
    const sla = pick(slaPool);
    const loc = pick(cityPool);
    const items = pickInt(1, 4);
    const gmv = pickInt(400, 8500);
    const fees = Math.round(gmv * (0.08 + rand() * 0.06));
    const net = gmv - fees;
    const dayOffset = pickInt(0, 14);
    const hour = pickInt(6, 22);
    const min = pickInt(0, 59);
    const date = new Date(2026, 0, 9 - dayOffset, hour, min);
    const hasIssues = rand() < 0.3;
    const issueCount = hasIssues ? pickInt(1, 3) : 0;

    orders.push({
      id: `ORD-${idx}`,
      seller: seller.name,
      sellerWsId: seller.wsId,
      marketplace,
      status,
      date: date.toISOString(),
      customer: pick(namePool),
      customerLoc: `${loc.city}, ${loc.state}`,
      items,
      gmv,
      net,
      payment,
      sla,
      risk,
      issueCount,
      syncHealth: rand() < 0.1 ? 'Failed' : rand() < 0.2 ? 'Warning' : 'Healthy',
      disputeFlag: rand() < 0.08,
    });
  }
  return orders;
}

export const globalOrders: Record<string, any>[] = generateOrders();

// KPIs derived from orders
const today = globalOrders.filter(o => new Date(o.date).toDateString() === new Date(2026, 0, 9).toDateString());
export const ordersKPIs: Record<string, any> = {
  totalToday: { value: today.length, delta: '+12%' },
  pending: { value: globalOrders.filter(o => ['New', 'Pending Confirmation', 'Confirmed', 'Packed'].includes(o.status)).length, delta: '-3%' },
  shippedToday: { value: today.filter(o => o.status === 'Shipped').length, delta: '+8%' },
  returnsOpen: { value: globalOrders.filter(o => ['Return Initiated', 'Returned'].includes(o.status)).length, delta: '+2' },
  refunds30d: { value: globalOrders.filter(o => ['Refund Pending', 'Refunded'].includes(o.status)).length, delta: '-1' },
  gmv30d: { value: globalOrders.reduce((s: number, o: Record<string, any>) => s + o.gmv, 0), delta: '+6.2%' },
};
